import React from 'react'

const Experience = (props) => {
  return (
    <div className="experience mb-5 rounded-[24px] border border-white/8 bg-white/[0.02] p-5">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <div className="md:col-span-4">
          <p className="inline-flex rounded-full border border-primary/15 bg-primary/8 px-4 py-2 text-sm font-medium text-primary md:text-base">{props.startYear} - {props.endYear}</p>
        </div>
        <div className="md:col-span-8">
          <h4 className="text-lg md:text-xl mt-0 font-semibold text-base-content">{props.jobName}</h4>
          <p className="text-sm md:text-base text-base-content/75"><strong className='text-base-content'>Company: </strong>{props.company} | <strong className='text-base-content'>Team: </strong>{props.team}</p>
          <div>
            <strong className='text-base-content'>Subject: </strong>
            {props.showSubjectList ? (
              <ul className="custom-list text-sm md:text-base text-base-content/75">
                {props.subject.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            ) : (
              <span className="text-sm md:text-base text-base-content/75">{props.subject}</span>
            )}
          </div>
          <p className="text-sm md:text-base text-base-content/75"><strong className='text-base-content'>Methods: </strong>{props.methods}</p>
          <p className="text-sm md:text-base text-base-content/75"><strong className='text-base-content'>Tools: </strong>{props.tools}</p>
          <p className="text-sm md:text-base text-base-content/75">{props.jobDescription}</p>
        </div>
      </div>
    </div>
  )
}

export default Experience
